import request from "@/utils/request"

// 获取铜仁协议签署列表
export function getTongRenProtocolList() {
  return request.post("/product/special/tongren/protocol");
}

export function specialSign(id) {
  return request.post("product/special/protocol/extension/sign", { id: id });
}